import { AuthRedirect } from "components/UtilsComponent/AuthRedirect";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "views/Auth/Auth";
import LoginSSO from "views/Auth/LoginSSO";
import LoginKeycloak from "views/Auth/LoginKeycloak";
import ConfirmLoginAfterKeycloakScreen from "views/Auth/ConfirmLoginAfterKeycloakScreen";

const enableKeycloakLoginPage =
  process.env.REACT_APP_ENABLE_KEYCLOAK_LOGIN_PAGE === "true";

export default function LoginRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="login" replace />} />

      <Route path="/sso" element={<LoginSSO />} />

      <Route
        path="/confirmLogin"
        element={<ConfirmLoginAfterKeycloakScreen />}
      />

      <Route element={<AuthRedirect />}>
        <Route
          path="login"
          element={enableKeycloakLoginPage ? <LoginKeycloak /> : <Login />}
        />
      </Route>
    </Routes>
  );
}
